<div class="lang-switcher" [class.is-open]="isOpen">
  <button
    type="button"
    class="lang-switcher__trigger"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    [attr.aria-label]="locale.isEn ? 'Change language' : '切換語言'"
    (click)="toggle()">
    <svg class="lang-switcher__globe" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10"/>
      <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20"/>
    </svg>
    <span class="lang-switcher__label">{{ currentLabel }}</span>
    <svg class="lang-switcher__chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path d="M6 9l6 6 6-6"/>
    </svg>
  </button>

  <ul class="lang-switcher__menu" role="listbox" *ngIf="isOpen">
    <li *ngFor="let opt of options"
        class="lang-switcher__option"
        [class.is-active]="opt.code === currentCode"
        role="option"
        [attr.aria-selected]="opt.code === currentCode">
      <a class="lang-switcher__option-link"
         [href]="hrefFor(opt.code)"
         (click)="onOptionClick(opt, $event)">
        <span class="lang-switcher__option-label">{{ opt.label }}</span>
        <svg *ngIf="opt.code === currentCode" class="lang-switcher__option-check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      </a>
    </li>
  </ul>
</div>
